import React from 'react'
import {
  Card,
  Col,
  Row,
  Typography
} from 'antd';

const { Title, Text} = Typography;
const Store = () => {
  return (
    <Row gutter={[16, 16]}>
            <Col span={24}>
                <Card bordered>
                    <Title level={3}>Welcome to Toshiba HUB</Title>
                    <Text>Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur. Quis aute iure reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint obcaecat cupiditat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</Text>
                </Card>
            </Col>
        </Row>
  )
}

export default Store